import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-preinvoicetype',
    templateUrl: './preinvoicetype.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})

export class PreinvoiceTypeComponent {
  routeLinks: any[];
  activeLinkIndex = 0;
  constructor(private router: Router) {
    this.routeLinks = [
      { label: 'Presupuesto', link: 'preinvoice' },
      { label: 'Recurrente', link: 'recurrent' }
    ];
  }
  public trackByIndex(i: number) { return i; }

}